import { SurveyPriorityFeedQuery } from 'capability-ng-survey';
import { TodoRefreshService } from 'capability-ng-todos';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IContentTileActionObj } from 'ui-ng-content-tile';
import { NavigationHistoryStack } from 'ui-ng-navbar';
import { PlatformUtility } from 'utility-ts-platform';
import { PollQueryModel } from '../../queries/poll_query_model';
import { RedirectAfterPollForSurveyCommand } from './../../commands/redirect_after_poll_for_survey_command';
import { ScheduledPollQuery } from './../../queries/scheduled_poll_query';
import { CheckScheduledPollsServant } from './../../servants/check_scheduled_poll_servant';
import { IBuiltPoll } from './../../servants/poll_results_servant';

interface IAppConfigModelStub {
  getConfigProperty(str: string): string;
  navIconTheme(): string;
  intakeOrFirstTermID(): string;
}

export class PollController {
  private _currentPoll: number;
  private _intakePollID: string;
  private poll: IBuiltPoll;
  private theme: string;
  private isLoading: boolean = true;
  private isMobile: boolean = false;

  constructor(
    private ngNavigationHistoryStack: NavigationHistoryStack,
    private $state: ng.ui.IStateService,
    private ngTodoRefreshService: TodoRefreshService,
    private ngScheduledPollQuery: ScheduledPollQuery,
    private loadPathPollCommand: ICommand,
    private loadActiveSurveysCommand: ICommand,
    private ngSurveyPriorityFeedQuery: SurveyPriorityFeedQuery,
    private ngCheckScheduledPollsServant: CheckScheduledPollsServant,
    private ngPollQueryModel: PollQueryModel,
    private ngRedirectAfterPollForSurvey: RedirectAfterPollForSurveyCommand,
    appConfigModel: IAppConfigModelStub
  ) {
    this.isMobile = PlatformUtility.isMobile();
    this._currentPoll = this.ngScheduledPollQuery.currentScheduledPoll as number;
    this.loadPoll();
    this.theme = appConfigModel.navIconTheme();
    this._intakePollID = appConfigModel.intakeOrFirstTermID();
    this.returningFromResourceDetailFix();
  }

  isMandatory(): boolean {
    return this.ngScheduledPollQuery.isMandatory();
  }

  isOptional(): boolean {
    return !this.ngScheduledPollQuery.isMandatory();
  }

  loadPoll(): void {
    if (this.ngScheduledPollQuery.continueScheduledPollsWorkflow()) {
      this.loadPathPollCommand(this._currentPoll).then(() => {
        this.poll = this.ngPollQueryModel.result;
        this.returningFromResourceDetailFix();
      });
    }
  }

  returningFromResourceDetailFix(): void {
    if (this.ngScheduledPollQuery.isShowResult()) {
      this.ngPollQueryModel.markPollAsFinished();
    }
  }

  dismiss(): void {
    this.ngScheduledPollQuery.dismissCurrentScheduledPoll().finally(this._handlePollCommands());
  }

  markComplete(): void {
    this.ngScheduledPollQuery.markPollAsFinished();
    this.ngPollQueryModel.markPollAsFinished();
  }

  afterComplete(): void {
    this.ngScheduledPollQuery.completeCurrentScheduledPoll().finally(this._handlePollCommands());
    if (this.isUpdatingIntakePoll()) {
      this.ngTodoRefreshService.showWithText('Updating your profile may have changed your To-Dos');
    }
  }
  private redirectAfterPoll() {
    this.ngRedirectAfterPollForSurvey.redirect();
  }

  private _handlePollCommands(): void {
    this.ngScheduledPollQuery.nextScheduledPoll();
    if (this.isUpdatingIntakePoll()) {
      this.ngNavigationHistoryStack.goBack();
    } else if (this.ngScheduledPollQuery.finishedScheduledPolls() || this._currentPollIsIntake()) {
      this.redirectAfterPoll();
    } else {
      this._currentPoll = this.ngScheduledPollQuery.currentScheduledPoll as number;
      this.loadPoll();
    }
  }

  private _currentPollIsIntake(): boolean {
    return this.poll.poll.id === _4.toNumber(this._intakePollID);
  }

  private isUpdatingIntakePoll(): boolean {
    return _4.get(this.$state, 'current.data.isIntakeUpdateMode', false);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/views/poll/poll.ts